/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Achievementsblade_Silver1Inputs */

const id_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perak`)
};

const ms_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perak`)
};

const da_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sølv`)
};

const de_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silber`)
};

const en_us2_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

const es_es2_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plata`)
};

const es_mx2_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plata`)
};

const fil_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

const fr_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Argent`)
};

const it_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Argento`)
};

const hu_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezüst`)
};

const nl_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zilver`)
};

const no_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sølv`)
};

const pl_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Srebro`)
};

const pt_br2_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

const pt_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prata`)
};

const ro_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Argint`)
};

const fi_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hopea`)
};

const sv_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

const vi_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạc`)
};

const tr_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gümüş`)
};

const cs_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stříbro`)
};

const bg_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сребро`)
};

const ru_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Серебро`)
};

const uk_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срібло`)
};

const ar_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فضة`)
};

const hi_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रजत`)
};

const th_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เงิน`)
};

const ja_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シルバー`)
};

const zh_cn2_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

const zh_hant1_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

const ko_components_achievementsblade_silver1 = /** @type {(inputs: Components_Achievementsblade_Silver1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silver`)
};

/**
* | output |
* | --- |
* | "Silver" |
*
* @param {Components_Achievementsblade_Silver1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_achievementsblade_silver1 = /** @type {((inputs?: Components_Achievementsblade_Silver1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Achievementsblade_Silver1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_achievementsblade_silver1(inputs)
	if (locale === "ms") return ms_components_achievementsblade_silver1(inputs)
	if (locale === "da") return da_components_achievementsblade_silver1(inputs)
	if (locale === "de") return de_components_achievementsblade_silver1(inputs)
	if (locale === "en-US") return en_us2_components_achievementsblade_silver1(inputs)
	if (locale === "es-ES") return es_es2_components_achievementsblade_silver1(inputs)
	if (locale === "es-MX") return es_mx2_components_achievementsblade_silver1(inputs)
	if (locale === "fil") return fil_components_achievementsblade_silver1(inputs)
	if (locale === "fr") return fr_components_achievementsblade_silver1(inputs)
	if (locale === "it") return it_components_achievementsblade_silver1(inputs)
	if (locale === "hu") return hu_components_achievementsblade_silver1(inputs)
	if (locale === "nl") return nl_components_achievementsblade_silver1(inputs)
	if (locale === "no") return no_components_achievementsblade_silver1(inputs)
	if (locale === "pl") return pl_components_achievementsblade_silver1(inputs)
	if (locale === "pt-BR") return pt_br2_components_achievementsblade_silver1(inputs)
	if (locale === "pt") return pt_components_achievementsblade_silver1(inputs)
	if (locale === "ro") return ro_components_achievementsblade_silver1(inputs)
	if (locale === "fi") return fi_components_achievementsblade_silver1(inputs)
	if (locale === "sv") return sv_components_achievementsblade_silver1(inputs)
	if (locale === "vi") return vi_components_achievementsblade_silver1(inputs)
	if (locale === "tr") return tr_components_achievementsblade_silver1(inputs)
	if (locale === "cs") return cs_components_achievementsblade_silver1(inputs)
	if (locale === "bg") return bg_components_achievementsblade_silver1(inputs)
	if (locale === "ru") return ru_components_achievementsblade_silver1(inputs)
	if (locale === "uk") return uk_components_achievementsblade_silver1(inputs)
	if (locale === "ar") return ar_components_achievementsblade_silver1(inputs)
	if (locale === "hi") return hi_components_achievementsblade_silver1(inputs)
	if (locale === "th") return th_components_achievementsblade_silver1(inputs)
	if (locale === "ja") return ja_components_achievementsblade_silver1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_achievementsblade_silver1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_achievementsblade_silver1(inputs)
	return ko_components_achievementsblade_silver1(inputs)
});
export { components_achievementsblade_silver1 as "components.achievementsBlade.silver" }